import { useState, useEffect } from "react";
import CloseIcon from "../../assets/hospitalCloseIcon.svg";
import RightArrow from "../../assets/rightArrowWhite.svg";
import Select from "react-select";
import { CaseServices } from "../../services/CaseServices";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { Field } from "formik";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
const ReferenceNotUploadedModal = ({
  setReferenceNotUploaded,
  setOpenInitiateReferenceModal,
  referenceNotUploaded,
  selectedScheme,
  caseType,
  setCaseType,
  stayDuration,
  setStayDuration,
  stratification,
  setStratification,
  subType,
  setSubType,
  admissionDate,
  setAdmissionDate,
  surgeryTreatmentStartDate,
  setSurgeryTreatmentStartDate,
  subTypeOptions,
  setSubTypeOptions,
}) => {
  console.log("selected scheme:", selectedScheme);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const selectStyle = {
    control: (base, state) => ({
      ...base,
      borderWidth: "0.5px",
      borderStyle: "solid",
      borderColor: "#017C71",
      paddingTop: "12px",
      paddingBottom: "12px",
      paddingLeft: "16px",
      paddingRight: "16px",
      borderRadius: "9999px", // rounded-full
      boxShadow: "none",
      "&:hover": {
        borderColor: "#017C71",
      },
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const resetInitiateAdmissionForm = () => {
    setCaseType("");
    setSubType("");
    setStayDuration("");
    setStratification("");
    setAdmissionDate("");
    setSurgeryTreatmentStartDate("");
  };

  const handleClose = () => {
    resetInitiateAdmissionForm();
    setReferenceNotUploaded(null);
  };

  const handleButtonClick = async () => {
    try {
      // const res = await CaseServices.updateCase(data, referenceNotUploaded);
      setReferenceNotUploaded(null);
      setOpenInitiateReferenceModal(true);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleProceedClick = async () => {
    setLoading(true);
    try {
      const data = {
        caseId: referenceNotUploaded,
        caseType,
        caseSubType: subType,
        admissionDate,
        surgeryTreatmentStartDate,
      };

      const res = await CaseServices?.initiateAdmissionDaycare(data);

      console.log("res:", res?.data);

      toast.success(res?.data?.message || "Proceed successful");

      navigate(`/dashboard/case-status/${referenceNotUploaded}`);
    } catch (error) {
      handleApiErrorResponses(error);
      toast.error("Something went wrong"); // optional but recommended
    }
    setLoading(false);
  };

  const getSubTypeList = async () => {
    try {
      const res = await CaseServices?.getSubTypeList("DAYCARE");
      setSubTypeOptions(res?.data?.masterData?.allmasterdata);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    getSubTypeList();
    return () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
      document.body.style.position = "";
      document.body.style.width = "";
    };
  }, []);
  console.log("selected sub type:", subType);
  return (
    <div className="fixed top-0 left-0 h-screen w-screen flex justify-center items-center bg-[#01716780] z-10 ">
      <div className="relative w-[45%] h-fit bg-white rounded-[30px] p-[18px]  2xl:p-6">
        {/* Close Button */}
        <div
          className="absolute top-1 right-2 cursor-pointer"
          onClick={handleClose}
        >
          <img src={CloseIcon} alt="close-icon" height={53} width={52} />
        </div>

        {/* Heading */}
        <div className="text-center text-[42px] 2xl:text-[48px] leading-[54px] -tracking-[4px]">
          Initiate Admission
        </div>

        <div className="text-[24px] 2x:text-[30px] text-center leading-[54px] -tracking-[1.5px] ">
          Upload OPD Notes with investigation reports
        </div>
        {/* Subtext */}
        <div className="text-center  text-[14px] 2xl:text-[16px] text-[#00000066] leading-[54px]">
          Please make sure they have all been successfully uploaded and
          verified.
        </div>
        <div className="border border-[#E8E8E8] border-solid mb-6" />
        <div className="flex items-center flex-wrap gap-y-[30px] gap-x-20 mt-4">
          {/* Case Type */}
          <div className="w-[40%]">
            <div className="text-[14px] -tracking-[0.36px] mb-1 2xl:mb-2">
              Case Type
            </div>
            <Select
              menuPlacement="auto"
              menuPortalTarget={document.body}
              components={{
                IndicatorSeparator: () => null,
              }}
              styles={selectStyle}
              options={[
                { label: "Surgical", value: "SURGICAL" },
                { label: "Conservative", value: "CONSERVATIVE" },
                { label: "Daycare", value: "DAYCARE" },
              ]}
              value={
                [
                  { label: "Surgical", value: "SURGICAL" },
                  { label: "Conservative", value: "CONSERVATIVE" },
                  { label: "Daycare", value: "DAYCARE" },
                ].find((option) => option.value === caseType) || null
              }
              onChange={(item) => {
                setCaseType(item.value);
                setSubType("");
                setStayDuration("");
                setStratification("");
              }}
            />
          </div>

          {/* subtype */}
          {selectedScheme?.value !== "TPA" && caseType === "DAYCARE" && (
            <div className="w-[40%]">
              <div className="text-[14px] -tracking-[0.36px] mb-1 2xl:mb-2">
                Case Sub-Type
              </div>
              <Select
                menuPlacement="auto"
                menuPortalTarget={document.body}
                components={{
                  IndicatorSeparator: () => null,
                }}
                styles={selectStyle}
                options={subTypeOptions}
                getOptionLabel={(options) => options["value"]}
                getOptionValue={(options) => options["value"]}
                value={
                  subTypeOptions?.find((option) => option.value === subType) ||
                  null
                }
                onChange={(item) => setSubType(item.value)}
              />
            </div>
          )}

          {selectedScheme?.value === "TPA" && (
            <div className="w-[40%]">
              <div className="text-[14px] -tracking-[0.36px] mb-1 2xl:mb-2">
                Ward
              </div>
              <Select
                menuPlacement="auto"
                menuPortalTarget={document.body}
                styles={selectStyle}
                components={{
                  IndicatorSeparator: () => null,
                }}
                options={[
                  { label: "ICU", value: "ICU" },
                  { label: "Presidential Suite", value: "Presidential Suite" },
                  { label: "Deluxe Room", value: "Deluxe Room" },
                  { label: "Private Room", value: "Private Room" },
                  { label: "Semi Private", value: "Semi Private" },
                  { label: "General Ward", value: "General Ward" },
                ]}
                value={
                  [
                    { label: "ICU", value: "ICU" },
                    {
                      label: "Presidential Suite",
                      value: "Presidential Suite",
                    },
                    { label: "Deluxe Room", value: "Deluxe Room" },
                    { label: "Private Room", value: "Private Room" },
                    { label: "Semi Private", value: "Semi Private" },
                    { label: "General Ward", value: "General Ward" },
                  ].find((option) => option.value === stratification) || null
                }
                onChange={(item) => setStratification(item.value)}
              />
            </div>
          )}

          {/* Ward */}
          {selectedScheme?.value !== "TPA" && caseType === "CONSERVATIVE" && (
            <div className="w-[40%]">
              <div className="text-[14px] -tracking-[0.36px] mb-1 2xl:mb-2">
                Ward
              </div>
              <Select
                menuPlacement="auto"
                menuPortalTarget={document.body}
                styles={selectStyle}
                components={{
                  IndicatorSeparator: () => null,
                }}
                options={[
                  { label: "Routine Ward", value: "Routine Ward" },
                  { label: "HDU", value: "HDU" },
                  {
                    label: "ICU with Ventilator",
                    value: "ICU with Ventilator",
                  },
                  {
                    label: "ICU without Ventilator",
                    value: "ICU without Ventilator",
                  },
                  { label: "NICU", value: "NICU" },
                ]}
                value={
                  [
                    { label: "Routine Ward", value: "Routine Ward" },
                    { label: "HDU", value: "HDU" },
                    {
                      label: "ICU with Ventilator",
                      value: "ICU with Ventilator",
                    },
                    {
                      label: "ICU without Ventilator",
                      value: "ICU without Ventilator",
                    },
                    { label: "NICU", value: "NICU" },
                  ].find((option) => option.value === stratification) || null
                }
                onChange={(item) => setStratification(item.value)}
              />
            </div>
          )}

          {/* Stay Duration */}
          {caseType === "CONSERVATIVE" && (
            <div className="w-[40%]">
              <div className="text-[14px] -tracking-[0.36px] mb-1 2xl:mb-2">
                Stay Duration
              </div>
              <Select
                menuPlacement="auto"
                menuPortalTarget={document.body}
                styles={selectStyle}
                components={{
                  IndicatorSeparator: () => null,
                }}
                options={[
                  { label: "1", value: "1" },
                  { label: "2", value: "2" },
                  { label: "3", value: "3" },
                  { label: "4", value: "4" },
                  { label: "5", value: "5" },
                  { label: "6", value: "6" },
                  { label: "7", value: "7" },
                  { label: "8", value: "8" },
                  { label: "9", value: "9" },
                  { label: "More Than 9", value: "More Than 9" },
                ]}
                value={
                  [
                    { label: "1", value: "1" },
                    { label: "2", value: "2" },
                    { label: "3", value: "3" },
                    { label: "4", value: "4" },
                    { label: "5", value: "5" },
                    { label: "6", value: "6" },
                    { label: "7", value: "7" },
                    { label: "8", value: "8" },
                    { label: "9", value: "9" },
                    { label: "More Than 9", value: "More Than 9" },
                  ].find((option) => option.value === stayDuration) || null
                }
                onChange={(item) => setStayDuration(item.value)}
              />
            </div>
          )}

          {/* Admission Date */}
          <div className="w-[38%]">
            <div className="text-[14px] -tracking-[0.36px] mb-2">
              Admission Date
            </div>

            <input
              className="w-full border-[0.5px] border-solid border-[#017C71] py-[18px] px-4 rounded-full "
              name="admissionDate"
              placeholder="Admission Date"
              type="date"
              value={admissionDate ? admissionDate.split("T")[0] : ""}
              max={new Date().toISOString().split("T")[0]}
              min={
                new Date(new Date().setDate(new Date().getDate() - 2))
                  .toISOString()
                  .split("T")[0]
              }
              onChange={(e) => {
                const selectedDate = e.target.value;

                // Just store value while typing
                if (selectedDate) {
                  setAdmissionDate(new Date(selectedDate).toISOString());
                } else if (selectedDate == "") {
                  setAdmissionDate("");
                }
              }}
              onBlur={(e) => {
                const selectedDate = e.target.value;

                if (!selectedDate) return;

                const today = new Date().toISOString().split("T")[0];

                const minDate = new Date(
                  new Date().setDate(new Date().getDate() - 2),
                )
                  .toISOString()
                  .split("T")[0];

                if (selectedDate < minDate || selectedDate > today) {
                  setAdmissionDate("");
                }
              }}
            />
          </div>
          {caseType && (
            <div className="w-[38%]">
              <div className="text-[14px] -tracking-[0.36px] mb-2">
                {caseType === "SURGICAL"
                  ? "Date Of Surgery"
                  : "Date Of Treatment"}
              </div>

              <input
                className="w-full border-[0.5px] border-solid border-[#017C71] py-[18px] px-4 rounded-full "
                name="surgeryTreatmentStartDate"
                placeholder="Select Date"
                type="date"
                value={
                  surgeryTreatmentStartDate
                    ? surgeryTreatmentStartDate.split("T")[0]
                    : ""
                }
                max={new Date().toISOString().split("T")[0]}
                min={
                  new Date(new Date().setDate(new Date().getDate() - 2))
                    .toISOString()
                    .split("T")[0]
                }
                onChange={(e) => {
                  const selectedDate = e.target.value;

                  // Just store value while typing
                  if (selectedDate) {
                    setSurgeryTreatmentStartDate(
                      new Date(selectedDate).toISOString(),
                    );
                  } else if (selectedDate == "") {
                    setSurgeryTreatmentStartDate("");
                  }
                }}
                onBlur={(e) => {
                  const selectedDate = e.target.value;

                  if (!selectedDate) return;

                  const today = new Date().toISOString().split("T")[0];

                  const minDate = new Date(
                    new Date().setDate(new Date().getDate() - 2),
                  )
                    .toISOString()
                    .split("T")[0];

                  if (selectedDate < minDate || selectedDate > today) {
                    setSurgeryTreatmentStartDate("");
                  }
                }}
              />
            </div>
          )}
        </div>
        {/* {console.log("admission date:", admissionDate)} */}

        {/* Proceed Button */}
        {caseType === "DAYCARE" &&
          subType &&
          surgeryTreatmentStartDate &&
          subType == "DIALYSIS" &&
          admissionDate && (
            <div className=" flex justify-center items-center mt-4 2xl:mt-6">
              {loading ? (
                <CircularProgress />
              ) : (
                <div
                  className="flex items-center gap-4 text-sm text-white bg-[#017C71] -tracking-[7%] rounded-full px-10 py-4 cursor-pointer"
                  onClick={handleProceedClick}
                >
                  Proceed
                  <img src={RightArrow} alt="arrow-icon" />
                </div>
              )}
            </div>
          )}
        {/* Upload Button */}
        {caseType &&
          surgeryTreatmentStartDate &&
          (caseType === "SURGICAL" ||
            (caseType === "CONSERVATIVE" && stayDuration && stratification) ||
            (caseType === "DAYCARE" &&
              ((subType && subType !== "DIALYSIS") ||
                selectedScheme?.value === "TPA"))) && (
            <div className="flex justify-center items-center mt-4 2xl:mt-6">
              <div
                className="flex items-center gap-4 text-sm text-white bg-[#017C71] -tracking-[3%] uppercase rounded-full px-10 py-4 cursor-pointer"
                onClick={handleButtonClick}
              >
                Upload Reference Document
                <img src={RightArrow} alt="arrow-icon" />
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default ReferenceNotUploadedModal;
